webpackJsonp([114276838955818,60335399758886],{

/***/ 110:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"matt harris"}}},"layoutContext":{}}

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(189);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(110);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 285:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.1
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function decode (s) {
			return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
		}
	
		function init (converter) {
			function api() {}
	
			function set (key, value, attributes) {
				if (typeof document === 'undefined') {
					return;
				}
	
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);
	
				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}
	
				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}
	
				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
	
				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);
	
				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
	
					// Considers RFC 6265 section 5.2:
					// ...
					// 3.  If the remaining unparsed-attributes contains a %x3B (";")
					//     character:
					// Consume the characters of the unparsed-attributes up to,
					// not including, the first %x3B (";") character.
					// ...
					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}
	
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}
	
			function get (key, json) {
				if (typeof document === 'undefined') {
					return;
				}
	
				var jar = {};
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all.
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = decode(parts[0]);
						cookie = (converter.read || converter)(cookie, name) ||
							decode(cookie);
	
						if (json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						jar[name] = cookie;
	
						if (key === name) {
							break;
						}
					} catch (e) {}
				}
	
				return key ? jar[key] : jar;
			}
	
			api.set = set;
			api.get = function (key) {
				return get(key, false /* read as raw */);
			};
			api.getJSON = function (key) {
				return get(key, true /* read as json */);
			};
			api.remove = function (key, attributes) {
				set(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.defaults = {};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),

/***/ 289:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(77);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactSpring = __webpack_require__(152);
	
	var _jsCookie = __webpack_require__(27);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _logo = __webpack_require__(406);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _constants = __webpack_require__(22);
	
	__webpack_require__(289);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Navigation = function (_Component) {
	  _inherits(Navigation, _Component);
	
	  function Navigation() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Navigation);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      pathPrefix: ''
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Navigation.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      var pathPrefix = _jsCookie2.default.get(_constants.PATH_PREFIX_COOKIE);
	      if (pathPrefix) {
	        _this2.setState({ pathPrefix: pathPrefix });
	      }
	    }, 500);
	  };
	
	  Navigation.prototype.render = function render() {
	    var pathPrefix = this.state.pathPrefix;
	
	    return _react2.default.createElement(
	      _reactSpring.Transition,
	      { config: _reactSpring.config.slow, from: { top: -50 }, enter: { top: 0 } },
	      function (styles) {
	        return _react2.default.createElement(
	          'ul',
	          { style: styles, className: 'nav justify-content-end p-2 fixed-top' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: 'nav-logo-link', to: pathPrefix + '/' },
	            _react2.default.createElement('img', { className: 'nav-logo', src: _logo2.default, alt: 'logo' })
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'nav-item' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { className: 'nav-link', to: pathPrefix + '/#work' },
	              'Work'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'nav-item' },
	            _react2.default.createElement(
	              'a',
	              {
	                className: 'nav-link',
	                href: '/Matt Harris Resume.pdf',
	                target: '_blank'
	              },
	              'Resume'
	            )
	          )
	        );
	      }
	    );
	  };
	
	  return Navigation;
	}(_react.Component);
	
	exports.default = Navigation;
	module.exports = exports['default'];

/***/ }),

/***/ 22:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var PATH_PREFIX_COOKIE = exports.PATH_PREFIX_COOKIE = 'mzhpathprefix';

/***/ }),

/***/ 403:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.dbfe6b33.png";

/***/ }),

/***/ 293:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Navigation = __webpack_require__(164);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	__webpack_require__(285);
	
	__webpack_require__(293);
	
	var _favicon = __webpack_require__(403);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = function Layout(_ref) {
	  var children = _ref.children,
	      data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      {
	        title: data.site.siteMetadata.title,
	        meta: [{ name: 'description', content: 'matt harris portfolio' }, { name: 'keywords', content: 'ux, design, portfolio, matt harris' }]
	      },
	      _react2.default.createElement('script', {
	        async: true,
	        src: 'https://www.googletagmanager.com/gtag/js?id=UA-128123257-1'
	      }),
	      _react2.default.createElement(
	        'script',
	        null,
	        'window.dataLayer = window.dataLayer || [];\n        function gtag(){dataLayer.push(arguments);}\n        gtag(\'js\', new Date());\n\n        gtag(\'config\', \'UA-128123257-1\');'
	      ),
	      _react2.default.createElement('link', { key: 'icon', rel: 'icon', href: _favicon2.default }),
	      _react2.default.createElement('link', {
	        href: 'https://fonts.googleapis.com/css?family=PT+Serif',
	        rel: 'stylesheet'
	      }),
	      _react2.default.createElement('script', {
	        defer: true,
	        src: 'https://use.fontawesome.com/releases/v5.4.1/js/all.js',
	        integrity: 'sha384-L469/ELG4Bg9sDQbl0hvjMq8pOcqFgkSpwhwnslzvVVGpDjYJ6wJJyYjvG3u8XW7',
	        crossorigin: 'anonymous'
	      })
	    ),
	    _react2.default.createElement(_Navigation2.default, null),
	    _react2.default.createElement(
	      'div',
	      null,
	      children()
	    )
	  );
	};
	
	Layout.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-b390ffe04bcfecf930e3.js